import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import AlertsGroup from "client_config/AlertsGroup";
import ManageSubsByClient from "alert_subscriptions/ManageSubsByClient";
import OnboardingAlertsGroup from "onboarding/AlertsGroup";

const addUser = (email, sectionName, sectionId) => {
  let returnedData = "";
  if (email && email != "" && sectionId && sectionId != "") {
    $.ajax({
      type: "POST",
      url: "/datapulse/alerts/subscribe-user/",
      async: false,
      data: {
        email: email,
        section_name: sectionName,
        section_id: sectionId,
      },
      success: (data) => {
        returnedData = data;
      },
    });
  }
  return returnedData;
};

const removeUser = (email, sectionName, sectionId) => {
  let removalSuccessful = false;
  if (email && email != "" && sectionId && sectionId != "") {
    $.ajax({
      type: "POST",
      url: "/datapulse/alerts/unsubscribe-user/",
      async: false,
      data: {
        email: email,
        section_name: sectionName,
        section_id: sectionId,
      },
      success: () => {
        removalSuccessful = true;
      },
    });
  }
  return removalSuccessful;
};

export default function Alerts(props) {
  const platforms = [
    {
      platformName: "Facebook Ads",
      alerts: [
        {
          name: "facebook_ads_social_impressions_emergency_detector",
          title: "Impressions Emergency Detector",
          desc: "Gets the number of Facebook Ads impressions for each account and if it falls beneath a certain threshold, emails all DP employees.",
        },
        {
          name: "facebook_ads_social_impressions_flux_detector",
          title: "Impressions Flux Detector",
          desc: "Creates an alert if Facebook Ads social impressions fall below or rise above a custom threshold",
          options: [
            { name: "min_threshold", title: "Min Threshold", placeholder: "Default 15%" },
            { name: "max_threshold", title: "Max Threshold", placeholder: "Default 300%" },
          ],
        },
        {
          name: "facebook_ads_social_spend_flux_detector",
          title: "Spend Flux Detector",
          desc: "Creates an alert if Facebook Ads social spend fall below or rise above a custom threshold",
          options: [
            { name: "min_threshold", title: "Min Threshold", placeholder: "Default 15%" },
            { name: "max_threshold", title: "Max Threshold", placeholder: "Default 300%" },
          ],
        },
        {
          name: "facebook_ads_social_clicks_flux_detector",
          title: "Clicks Flux Detector",
          desc: "Creates an alert if Facebook Ads social clicks fall below or rise above a custom threshold",
          options: [
            { name: "min_threshold", title: "Min Threshold", placeholder: "Default 15%" },
            { name: "max_threshold", title: "Max Threshold", placeholder: "Default 300%" },
          ],
        },
        {
          name: "facebook_ads_social_conversions_flux_detector",
          title: "Conversions Flux Detector",
          desc: "Creates an alert if Facebook Ads social conversions fall below or rise above a custom threshold",
          options: [
            { name: "min_threshold", title: "Min Threshold", placeholder: "Default 15%" },
            { name: "max_threshold", title: "Max Threshold", placeholder: "Default 300%" },
          ],
        },
        {
          name: "facebook_ads_social_conversion_rate_flux_detector",
          title: "Conversion Rate Flux Detector",
          desc: "Creates an alert if Facebook Ads social conversion rate fall below or rise above a custom threshold",
          options: [
            { name: "min_threshold", title: "Min Threshold", placeholder: "Default 15%" },
            { name: "max_threshold", title: "Max Threshold", placeholder: "Default 300%" },
          ],
        },
      ],
    },
  ];

  return (
    <>
      <Container style={{ backgroundColor: props.onboarding ? "#f5f5f5" : undefined }} fluid className="p-3">
        <Row>
          <Col>
            <div className="pt-4 pb-2">
              <p className="text-info f18 visby-bold">Alerts:</p>
            </div>
          </Col>
        </Row>
        <Row>
         <Col className="pr-0 pr-md-5 pl-0 pl-md-4" xl={8}>
            <div className="pb-4 px-3">
              {platforms.map((platform) => {
                return props.onboarding ? (
                  <OnboardingAlertsGroup
                    key={platform.platformName}
                    platform={platform}
                    service="social"
                    scripts={props.socialScripts}
                    scriptVariables={props.socialScriptsVar}
                    setScripts={props.setSocialScripts}
                    setScriptsVar={props.setSocialScriptsVar}
                    onboarding
                  />
                ) : (
                  <AlertsGroup
                    key={platform.platformName}
                    platform={platform}
                    service="social"
                    scripts={props.social_section.scripts}
                    scriptVariables={props.social_section.script_variables}
                  />
                );
              })}
            </div>
          </Col>
          <Col xl={4}>
            <div
              className="subs-by-client pt-4 mb-4 px-3"
              style={{
                backgroundColor: "#e1e1e1",
                paddingBottom: "150px"
              }}>
              <h5>Subscribed to these alerts:</h5>
              <ManageSubsByClient
                users={props.users}
                addUser={addUser}
                removeUser={removeUser}
                subscribed_users={props.subs.social_subs}
                section_id={props.subs.social_section_id}
                section_name="SocialSection"
                client_name={props.company_name}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
